<template>
  <div>
    <slot name="title"></slot>
    <div v-for="(item,index) in list" :key="index" class="newList-li">
        <div class="newList-li-line" :class="isActive == index?'newList-li-line-active':''"  v-if="index < listNum" @click="clickItem(item,index)">
            <!-- <p><a :href="href(item.id)">{{item.contentTitle}}</a></p>
            <span>{{}}</span> -->
            <div class="newList-li-line-time">
                <div style="font-size: 28px;">{{item.modifyTime | datefilterYear}}</div>
                <div>{{item.modifyTime | datefilterDay}}</div>
            </div>
            <div class="newList-li-line-txt">
                <div>
                    {{item.contentTitle}}
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
/**
 * Component newsList 新闻列表组件
 	@author fanjun
  @props data（必选属性前面带＊，非必选项目请备注默认值）
    -*list:Array ,列表数据
    -type:String ,'1'(默认)-1、列表首条图文展示 、 2、列表文字展示
    -*link:String ,链接地址 
    -listNum:Number,5(默认)-渲染列表数量
	@example
	<NewsList v-bind="{'type':'1','list':newsData,,'listNum':5,'link':'./login.html'}">
    <template v-slot:title>
      标题
    </template>
  </NewsList>
**/
import './index.scss'
export default {
  name: 'Nav',
  components:{
  },
  props:{
    list:{
      require:true,
      type:Array,
    },
    link:{
      require:true,
      type:String,
    },
    type:{
      type:String,
      default:'1',
    },
    listNum:{
      type:Number,
      default:5,
    }
  },
  data(){
    return{
      isActive: 0
    }
  },
  filters:{
    datefilterYear:function(val){
      var date = new Date(val);  
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      return y ;
    },
    datefilterDay:function(val){
      var date = new Date(val);  
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      return m + '-' + d ;
    }
  },
  methods: {
    href(id){
      if(this.link.indexOf('?')!=-1){
        return this.link+'&id='+id
      }else{
        return this.link+'?id='+id
      }
    },
    clickItem(item, index){
      this.isActive = index
      this.$emit('clickItem',item)
    }
  }
}
</script>

